export default __webpack_public_path__ + "static/media/330_dummy2016-restaurant02-mobile-de.92f56657.png";